<h2 mat-dialog-title>
  {{'AGENTS.SELECT_AGENT' | translate | uppercase }}
</h2>

<mat-dialog-content class="agent-dialog-content">
  <mat-form-field appearance="outline" class="agent-filter-field">
    <mat-label>{{ 'AGENTS.FILTER_AGENTS' | translate }}</mat-label>
    <input
      matInput
      [formControl]="_agentFilter"
      placeholder="{{ 'AGENTS.SEARCH_PLACEHOLDER' | translate }}"
    />
  </mat-form-field>

  <mat-selection-list #agent class="agent-list" [multiple]="false">
    @for (agent of this._agents | async; track agent.Agent.AgentId) {
      <mat-list-option class="agent-option" [value]="agent.Agent.AgentId">
        <div class="agent-option-text">
          <div class="agent-name">{{agent.Agent.LastName}}, {{agent.Agent.FirstName}}</div>
          <div class="agent-business">{{agent.Agent.BusinessName}}</div>
        </div>
      </mat-list-option>
    } @empty {
      <div class="agent-empty-state">{{ 'AGENTS.NO_AGENTS_MATCH' | translate }}</div>
    }
  </mat-selection-list>
</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button [disabled]="agent.selectedOptions.selected.length === 0" [mat-dialog-close]="agent.selectedOptions.selected[0]?.value" cdkFocusInitial >{{ 'GENERAL.ADD' | translate | uppercase }}</button>
  <button mat-button [mat-dialog-close]=""  >{{ 'GENERAL.CANCEL' | translate | uppercase }}</button>
</div>
